module.exports = __webpack_public_path__ + "static/media/login.cb0334e0.png";